import React, {Component} from "react";
import AddBlogForm from "../elements/AddBlogForm";
import Button from "../ui-kit/Button";
import i18nRepo from "../../i18n-repo/i18nRepo";
import {connect} from "react-redux";
import {setLoading} from "../../store/actions/creators/appActionCreator";
import {message} from "../ui-kit/MessageGate";
import BlogService from "../../services/BlogService";
import withAuth from "../high-order-components/Auth-HOC";

class AddBlog extends Component
{
  constructor (props)
  {
    super(props);

    this.service = new BlogService();

    this.formRef = React.createRef();
  }

  onSubmit = async (values) =>
  {
    try
    {
      this.props.setLoading(true);

      await this.service.create(values, this.props.language);

      message({
                type: "success",
                content: i18nRepo.getSentence("we_successfully_added_this_post")
              });
    }
    catch (error)
    {
      if (error.statusCode === 401)
      {
        this.props.authActions.logout();
      }

      message({
                type: "error",
                content: i18nRepo.getError("we_could_not_add_this_post")
              });
    }
    finally
    {
      this.props.setLoading(false);
    }
  };

  onClickSubmit = () =>
  {
    this.formRef.current.submit();
  };

  render ()
  {
    return (
      <div className={"initial-page add-blog"}>
        <div className={"add-blog__content-wrapper"}>
          <div className={"add-blog__header-wrapper"}>
            {
              i18nRepo.getSentence("add_blog")
            }
          </div>

          <div className={"add-blog__form-wrapper"}>
            <AddBlogForm
              onSubmit={this.onSubmit}
              formRef={this.formRef}
            />
          </div>

          <div className={"add-blog__button-wrapper"}>
            <Button
              text={i18nRepo.getWord("add")}
              onClick={this.onClickSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setLoading: (loading) => dispatch(setLoading(loading))
});

export default withAuth(connect(null, mapDispatchToProps)(AddBlog));